/**
 * The admin console's React Query defaults. `main.tsx` builds its client from
 * these, and tests that need the console's real caching import them rather
 * than restating them.
 */
export const ADMIN_QUERY_DEFAULTS = {
	refetchOnWindowFocus: false,
	retry: 1,
	staleTime: 60_000,
} as const;
